import * as ko from 'knockout';
import entityBase from 'entityBase';

export class part extends entityBase {
    internal_descriptn: KnockoutObservable<string>;
    part_id           : KnockoutObservable<string>;
    part_status       : KnockoutObservable<string>;
    part_type         : KnockoutObservable<string>;
    user_def3         : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.internal_descriptn = ko.observable(item.internal_descriptn).extend({ maxLength: 50 });
        this.part_id            = ko.observable(item.part_id).extend({ maxLength: 128 });
        this.part_status        = ko.observable(item.part_status).extend({ maxLength: 128 });
        this.part_type          = ko.observable(item.part_type).extend({ maxLength: 128 });
        this.user_def3          = ko.observable(item.user_def3).extend({ maxLength: 50 });
    }
}


